<template>

    <v-flex xs12 sm12 md10 lg8 offset-md1 offset-lg2>

        <div class="menu-btn-group" style="width: 100%">

            <v-btn v-for="(m, index) in menuList" :key="index" class="menu-button font-size transparent-bg" @click.prevent="$router.push({name: m.url})">

                <v-layout row wrap>

                    <v-flex xs12 style="position: relative;">

                        <v-img :src="m.image" contain></v-img>

                        <div class="overlay">

                            <span class="home-menu-title">{{ $t('home_menu.' + m.name.toLowerCase().replace(/ /g,"_") ) }}</span>

                        </div>

                    </v-flex>

                </v-layout>

            </v-btn>

        </div>

    </v-flex>

</template>

<script>
export default {
    props: ["menu"],
    data() {
        return {
        }
    },
    computed: {
        menuList: function() {
            if(this.$store.getters.user_token != "") {
                return this.menu ? this.menu.after : [];
            } else {
                return this.menu ? this.menu.before: [];
            }
        }
    },
}
</script>

<style scoped>

    .home-icon-wallet-margin {
        margin: 0px;
    }

    .menu-btn-group {
        background-color: rgb(0 13 25 / 90%);
    }

    .menu-btn-group .v-btn__content {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .menu-button {
        height: 100%;
        width: 33.33%;
        border: 1px solid #66666600;
        color: #666666;
        font-weight: bold;
    }

    .menu-btn-group .v-btn {
        margin: 0px;
    }

     .menu-button:hover .overlay {
        height: 100%;
        background-color: rgb(106 0 150 / 70%);
    }

    .menu-btn-group {
        background-color: black;
    }

    .home-menu-title{
        font-size: calc(0.6em + 1.5vmin);
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
    }

    .overlay {
        color: white;
        width: 100%;
        height: 0;
        overflow: hidden;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        display: -webkit-box;
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
        transition: .5s ease;
    }

</style>

<style>

    .menu-button:hover .v-btn__content .layout .flex .v-image .v-image__image {
        -webkit-filter: blur(5px);
        filter: blur(5px);
        -webkit-transform: scale3d(1.1,1.1,1.1);
        transform: scale3d(1.1,1.1,1.1);
        transition: -webkit-transform 1s ease;
        -webkit-transition: -webkit-transform 1s ease;
        transition: transform 1s ease;
        transition: transform 1s ease,-webkit-transform 1s ease;
    }

</style>
